import React from 'react';

export const NotFoundIcon = () => (
  <svg height="248" viewBox="0 0 255 248" width="255" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Group 3495" id="Group_3495" transform="translate(-525 -191)">
      <ellipse
        cx="127.5"
        cy="124"
        data-name="Ellipse 16"
        fill="#f8f8f8"
        id="Ellipse_16"
        rx="127.5"
        ry="124"
        transform="translate(525 191)"
      />
    </g>
    <path
      d="M485,485l-32.666-32.666m10.888-27.223A38.111,38.111,0,1,1,425.111,387,38.112,38.112,0,0,1,463.222,425.111Z"
      data-name="Path 1271"
      fill="none"
      id="Path_1271"
      stroke="#0a3256"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="10"
      transform="translate(-302 -306.5)"
    />
  </svg>
);
